module.exports = __webpack_public_path__ + "img/empty-transaction.462038ab.svg";